import css from 'styled-jsx/css';

export default css`
  .Modal__backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 1000;
  }

  .Modal {
    min-height: 300px;
  }

  .SmallCoolVotingButtonsModal {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-height: unset;
  }
`;
